
export enum SchedulePostProcessorType {
  Basic = 'Basic',
  Clustered = 'Clustered',
}
